import s from './WorksheetHtmlPreview.module.css';

const ASPECT = { a4: 841.89 / 595.28, letter: 792 / 612 };

export default function WorksheetHtmlPreview({ characters = [], paperSize = 'a4' }) {
  const ratio = ASPECT[paperSize] || ASPECT.a4;
  const previewChars = characters.slice(0, 2);
  const today = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  return (
    <div className={s.wrapper}>
      <div className={s.page} style={{ aspectRatio: `1 / ${ratio}` }}>
        {previewChars.map((c, i) => {
          const char = c.char || c.simplified_char || '?';
          const pinyin = c.pinyin || '';
          const meaning = c.definition_en || c.meaning || '';
          const radical = c.radical || '';
          const strokes = c.stroke_count ?? '';

          return (
            <div key={i} className={s.charSection}>
              {/* Info header */}
              <div className={s.infoHeader}>
                <div className={s.infoLeft}>
                  <span className={s.infoChar}>{char}</span>
                  <span className={s.infoPinyin}>{pinyin}</span>
                </div>
                <div className={s.infoRight}>
                  {radical && (
                    <div className={s.infoRow}>
                      <span className={s.infoLabel}>部首</span>
                      <span className={s.infoValue}>{radical}</span>
                    </div>
                  )}
                  {strokes !== '' && (
                    <div className={s.infoRow}>
                      <span className={s.infoLabel}>笔画</span>
                      <span className={s.infoValue}>{strokes}</span>
                    </div>
                  )}
                  {meaning && (
                    <div className={s.infoRow}>
                      <span className={s.infoLabel}>Meaning</span>
                      <span className={s.infoValue}>{meaning}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Stroke order placeholder */}
              <div className={s.strokeRow}>
                <span className={s.strokeLabel}>笔顺</span>
                <div className={s.strokeBoxes}>
                  {[0, 1, 2, 3, 4].map((j) => (
                    <div key={j} className={s.strokeBox} />
                  ))}
                </div>
              </div>

              {/* Practice grid */}
              <div className={s.grid}>
                {[0, 1, 2].map((row) => (
                  <div key={row} className={s.gridRow}>
                    {[0, 1, 2, 3, 4, 5].map((col) => (
                      <div key={col} className={s.gridCell}>
                        <div className={s.crosshairH} />
                        <div className={s.crosshairV} />
                        {col === 0 && (
                          <span className={s.traceChar}>{char}</span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {/* Footer */}
        <div className={s.footer}>
          WanderWords · Page 1 · {today}
        </div>
      </div>
    </div>
  );
}
